module.exports = __webpack_public_path__ + "img/expand-arrow-down-small-disabled.debfa6f7.svg";